import {useMutation, gql} from '@apollo/client'

const useCreateEventMutation = (onSuccess = () => {}, onDelete = () => {}) => {
    return useMutation(
        gql`
            mutation (
                $newEvent: EventInput!
                ) {
                createEvent (
                    newEvent: $newEvent
                )  {
                    name
                    tbd
                    id
                    kind
                    startDate
                    endDate
                    busy
                    userIdsInvolved
                    createdAt
                    updatedAt
                    googleCalendarEventId
                    description
                }
            }
        `,
        {
            onCompleted: (result) => {
                onSuccess(result)
            },
            onError: () => {
                onDelete()
            }
        }
    )
}

export default useCreateEventMutation